export default __webpack_public_path__ + "static/media/p68 Moving Tips.c51a395b.pdf";